export default __webpack_public_path__ + "static/media/landingmain.b3f938fc.jpg";